// Comprehensive country list: ISO-2 code, English name, Arabic name, dial code, flag emoji.
// Used by phone-number inputs, KYC country dropdowns, and any country selector.
export const COUNTRIES = [
  { code: 'AF', name: 'Afghanistan', ar: 'أفغانستان', dial: '+93', flag: '🇦🇫' },
  { code: 'AL', name: 'Albania', ar: 'ألبانيا', dial: '+355', flag: '🇦🇱' },
  { code: 'DZ', name: 'Algeria', ar: 'الجزائر', dial: '+213', flag: '🇩🇿' },
  { code: 'AD', name: 'Andorra', ar: 'أندورا', dial: '+376', flag: '🇦🇩' },
  { code: 'AO', name: 'Angola', ar: 'أنغولا', dial: '+244', flag: '🇦🇴' },
  { code: 'AG', name: 'Antigua and Barbuda', ar: 'أنتيغوا وباربودا', dial: '+1268', flag: '🇦🇬' },
  { code: 'AR', name: 'Argentina', ar: 'الأرجنتين', dial: '+54', flag: '🇦🇷' },
  { code: 'AM', name: 'Armenia', ar: 'أرمينيا', dial: '+374', flag: '🇦🇲' },
  { code: 'AU', name: 'Australia', ar: 'أستراليا', dial: '+61', flag: '🇦🇺' },
  { code: 'AT', name: 'Austria', ar: 'النمسا', dial: '+43', flag: '🇦🇹' },
  { code: 'AZ', name: 'Azerbaijan', ar: 'أذربيجان', dial: '+994', flag: '🇦🇿' },
  { code: 'BS', name: 'Bahamas', ar: 'باهاماس', dial: '+1242', flag: '🇧🇸' },
  { code: 'BH', name: 'Bahrain', ar: 'البحرين', dial: '+973', flag: '🇧🇭' },
  { code: 'BD', name: 'Bangladesh', ar: 'بنغلاديش', dial: '+880', flag: '🇧🇩' },
  { code: 'BB', name: 'Barbados', ar: 'بربادوس', dial: '+1246', flag: '🇧🇧' },
  { code: 'BY', name: 'Belarus', ar: 'بيلاروسيا', dial: '+375', flag: '🇧🇾' },
  { code: 'BE', name: 'Belgium', ar: 'بلجيكا', dial: '+32', flag: '🇧🇪' },
  { code: 'BZ', name: 'Belize', ar: 'بليز', dial: '+501', flag: '🇧🇿' },
  { code: 'BJ', name: 'Benin', ar: 'بنين', dial: '+229', flag: '🇧🇯' },
  { code: 'BT', name: 'Bhutan', ar: 'بوتان', dial: '+975', flag: '🇧🇹' },
  { code: 'BO', name: 'Bolivia', ar: 'بوليفيا', dial: '+591', flag: '🇧🇴' },
  { code: 'BA', name: 'Bosnia and Herzegovina', ar: 'البوسنة والهرسك', dial: '+387', flag: '🇧🇦' },
  { code: 'BW', name: 'Botswana', ar: 'بوتسوانا', dial: '+267', flag: '🇧🇼' },
  { code: 'BR', name: 'Brazil', ar: 'البرازيل', dial: '+55', flag: '🇧🇷' },
  { code: 'BN', name: 'Brunei', ar: 'بروناي', dial: '+673', flag: '🇧🇳' },
  { code: 'BG', name: 'Bulgaria', ar: 'بلغاريا', dial: '+359', flag: '🇧🇬' },
  { code: 'BF', name: 'Burkina Faso', ar: 'بوركينا فاسو', dial: '+226', flag: '🇧🇫' },
  { code: 'BI', name: 'Burundi', ar: 'بوروندي', dial: '+257', flag: '🇧🇮' },
  { code: 'KH', name: 'Cambodia', ar: 'كمبوديا', dial: '+855', flag: '🇰🇭' },
  { code: 'CM', name: 'Cameroon', ar: 'الكاميرون', dial: '+237', flag: '🇨🇲' },
  { code: 'CA', name: 'Canada', ar: 'كندا', dial: '+1', flag: '🇨🇦' },
  { code: 'CV', name: 'Cape Verde', ar: 'الرأس الأخضر', dial: '+238', flag: '🇨🇻' },
  { code: 'CF', name: 'Central African Republic', ar: 'جمهورية أفريقيا الوسطى', dial: '+236', flag: '🇨🇫' },
  { code: 'TD', name: 'Chad', ar: 'تشاد', dial: '+235', flag: '🇹🇩' },
  { code: 'CL', name: 'Chile', ar: 'تشيلي', dial: '+56', flag: '🇨🇱' },
  { code: 'CN', name: 'China', ar: 'الصين', dial: '+86', flag: '🇨🇳' },
  { code: 'CO', name: 'Colombia', ar: 'كولومبيا', dial: '+57', flag: '🇨🇴' },
  { code: 'KM', name: 'Comoros', ar: 'جزر القمر', dial: '+269', flag: '🇰🇲' },
  { code: 'CG', name: 'Congo', ar: 'الكونغو', dial: '+242', flag: '🇨🇬' },
  { code: 'CD', name: 'Congo, DR', ar: 'جمهورية الكونغو الديمقراطية', dial: '+243', flag: '🇨🇩' },
  { code: 'CR', name: 'Costa Rica', ar: 'كوستاريكا', dial: '+506', flag: '🇨🇷' },
  { code: 'CI', name: "Côte d'Ivoire", ar: 'ساحل العاج', dial: '+225', flag: '🇨🇮' },
  { code: 'HR', name: 'Croatia', ar: 'كرواتيا', dial: '+385', flag: '🇭🇷' },
  { code: 'CU', name: 'Cuba', ar: 'كوبا', dial: '+53', flag: '🇨🇺' },
  { code: 'CY', name: 'Cyprus', ar: 'قبرص', dial: '+357', flag: '🇨🇾' },
  { code: 'CZ', name: 'Czech Republic', ar: 'التشيك', dial: '+420', flag: '🇨🇿' },
  { code: 'DK', name: 'Denmark', ar: 'الدنمارك', dial: '+45', flag: '🇩🇰' },
  { code: 'DJ', name: 'Djibouti', ar: 'جيبوتي', dial: '+253', flag: '🇩🇯' },
  { code: 'DM', name: 'Dominica', ar: 'دومينيكا', dial: '+1767', flag: '🇩🇲' },
  { code: 'DO', name: 'Dominican Republic', ar: 'جمهورية الدومينيكان', dial: '+1809', flag: '🇩🇴' },
  { code: 'EC', name: 'Ecuador', ar: 'الإكوادور', dial: '+593', flag: '🇪🇨' },
  { code: 'EG', name: 'Egypt', ar: 'مصر', dial: '+20', flag: '🇪🇬' },
  { code: 'SV', name: 'El Salvador', ar: 'السلفادور', dial: '+503', flag: '🇸🇻' },
  { code: 'GQ', name: 'Equatorial Guinea', ar: 'غينيا الاستوائية', dial: '+240', flag: '🇬🇶' },
  { code: 'ER', name: 'Eritrea', ar: 'إريتريا', dial: '+291', flag: '🇪🇷' },
  { code: 'EE', name: 'Estonia', ar: 'إستونيا', dial: '+372', flag: '🇪🇪' },
  { code: 'SZ', name: 'Eswatini', ar: 'إسواتيني', dial: '+268', flag: '🇸🇿' },
  { code: 'ET', name: 'Ethiopia', ar: 'إثيوبيا', dial: '+251', flag: '🇪🇹' },
  { code: 'FJ', name: 'Fiji', ar: 'فيجي', dial: '+679', flag: '🇫🇯' },
  { code: 'FI', name: 'Finland', ar: 'فنلندا', dial: '+358', flag: '🇫🇮' },
  { code: 'FR', name: 'France', ar: 'فرنسا', dial: '+33', flag: '🇫🇷' },
  { code: 'GA', name: 'Gabon', ar: 'الغابون', dial: '+241', flag: '🇬🇦' },
  { code: 'GM', name: 'Gambia', ar: 'غامبيا', dial: '+220', flag: '🇬🇲' },
  { code: 'GE', name: 'Georgia', ar: 'جورجيا', dial: '+995', flag: '🇬🇪' },
  { code: 'DE', name: 'Germany', ar: 'ألمانيا', dial: '+49', flag: '🇩🇪' },
  { code: 'GH', name: 'Ghana', ar: 'غانا', dial: '+233', flag: '🇬🇭' },
  { code: 'GR', name: 'Greece', ar: 'اليونان', dial: '+30', flag: '🇬🇷' },
  { code: 'GD', name: 'Grenada', ar: 'غرينادا', dial: '+1473', flag: '🇬🇩' },
  { code: 'GT', name: 'Guatemala', ar: 'غواتيمالا', dial: '+502', flag: '🇬🇹' },
  { code: 'GN', name: 'Guinea', ar: 'غينيا', dial: '+224', flag: '🇬🇳' },
  { code: 'GW', name: 'Guinea-Bissau', ar: 'غينيا بيساو', dial: '+245', flag: '🇬🇼' },
  { code: 'GY', name: 'Guyana', ar: 'غيانا', dial: '+592', flag: '🇬🇾' },
  { code: 'HT', name: 'Haiti', ar: 'هايتي', dial: '+509', flag: '🇭🇹' },
  { code: 'HN', name: 'Honduras', ar: 'هندوراس', dial: '+504', flag: '🇭🇳' },
  { code: 'HK', name: 'Hong Kong', ar: 'هونغ كونغ', dial: '+852', flag: '🇭🇰' },
  { code: 'HU', name: 'Hungary', ar: 'هنغاريا', dial: '+36', flag: '🇭🇺' },
  { code: 'IS', name: 'Iceland', ar: 'آيسلندا', dial: '+354', flag: '🇮🇸' },
  { code: 'IN', name: 'India', ar: 'الهند', dial: '+91', flag: '🇮🇳' },
  { code: 'ID', name: 'Indonesia', ar: 'إندونيسيا', dial: '+62', flag: '🇮🇩' },
  { code: 'IR', name: 'Iran', ar: 'إيران', dial: '+98', flag: '🇮🇷' },
  { code: 'IQ', name: 'Iraq', ar: 'العراق', dial: '+964', flag: '🇮🇶' },
  { code: 'IE', name: 'Ireland', ar: 'أيرلندا', dial: '+353', flag: '🇮🇪' },
  { code: 'IL', name: 'Israel', ar: 'إسرائيل', dial: '+972', flag: '🇮🇱' },
  { code: 'IT', name: 'Italy', ar: 'إيطاليا', dial: '+39', flag: '🇮🇹' },
  { code: 'JM', name: 'Jamaica', ar: 'جامايكا', dial: '+1876', flag: '🇯🇲' },
  { code: 'JP', name: 'Japan', ar: 'اليابان', dial: '+81', flag: '🇯🇵' },
  { code: 'JO', name: 'Jordan', ar: 'الأردن', dial: '+962', flag: '🇯🇴' },
  { code: 'KZ', name: 'Kazakhstan', ar: 'كازاخستان', dial: '+7', flag: '🇰🇿' },
  { code: 'KE', name: 'Kenya', ar: 'كينيا', dial: '+254', flag: '🇰🇪' },
  { code: 'KI', name: 'Kiribati', ar: 'كيريباتي', dial: '+686', flag: '🇰🇮' },
  { code: 'KW', name: 'Kuwait', ar: 'الكويت', dial: '+965', flag: '🇰🇼' },
  { code: 'KG', name: 'Kyrgyzstan', ar: 'قيرغيزستان', dial: '+996', flag: '🇰🇬' },
  { code: 'LA', name: 'Laos', ar: 'لاوس', dial: '+856', flag: '🇱🇦' },
  { code: 'LV', name: 'Latvia', ar: 'لاتفيا', dial: '+371', flag: '🇱🇻' },
  { code: 'LB', name: 'Lebanon', ar: 'لبنان', dial: '+961', flag: '🇱🇧' },
  { code: 'LS', name: 'Lesotho', ar: 'ليسوتو', dial: '+266', flag: '🇱🇸' },
  { code: 'LR', name: 'Liberia', ar: 'ليبيريا', dial: '+231', flag: '🇱🇷' },
  { code: 'LY', name: 'Libya', ar: 'ليبيا', dial: '+218', flag: '🇱🇾' },
  { code: 'LI', name: 'Liechtenstein', ar: 'ليختنشتاين', dial: '+423', flag: '🇱🇮' },
  { code: 'LT', name: 'Lithuania', ar: 'ليتوانيا', dial: '+370', flag: '🇱🇹' },
  { code: 'LU', name: 'Luxembourg', ar: 'لوكسمبورغ', dial: '+352', flag: '🇱🇺' },
  { code: 'MO', name: 'Macao', ar: 'ماكاو', dial: '+853', flag: '🇲🇴' },
  { code: 'MG', name: 'Madagascar', ar: 'مدغشقر', dial: '+261', flag: '🇲🇬' },
  { code: 'MW', name: 'Malawi', ar: 'مالاوي', dial: '+265', flag: '🇲🇼' },
  { code: 'MY', name: 'Malaysia', ar: 'ماليزيا', dial: '+60', flag: '🇲🇾' },
  { code: 'MV', name: 'Maldives', ar: 'جزر المالديف', dial: '+960', flag: '🇲🇻' },
  { code: 'ML', name: 'Mali', ar: 'مالي', dial: '+223', flag: '🇲🇱' },
  { code: 'MT', name: 'Malta', ar: 'مالطا', dial: '+356', flag: '🇲🇹' },
  { code: 'MH', name: 'Marshall Islands', ar: 'جزر مارشال', dial: '+692', flag: '🇲🇭' },
  { code: 'MR', name: 'Mauritania', ar: 'موريتانيا', dial: '+222', flag: '🇲🇷' },
  { code: 'MU', name: 'Mauritius', ar: 'موريشيوس', dial: '+230', flag: '🇲🇺' },
  { code: 'MX', name: 'Mexico', ar: 'المكسيك', dial: '+52', flag: '🇲🇽' },
  { code: 'FM', name: 'Micronesia', ar: 'ميكرونيزيا', dial: '+691', flag: '🇫🇲' },
  { code: 'MD', name: 'Moldova', ar: 'مولدوفا', dial: '+373', flag: '🇲🇩' },
  { code: 'MC', name: 'Monaco', ar: 'موناكو', dial: '+377', flag: '🇲🇨' },
  { code: 'MN', name: 'Mongolia', ar: 'منغوليا', dial: '+976', flag: '🇲🇳' },
  { code: 'ME', name: 'Montenegro', ar: 'الجبل الأسود', dial: '+382', flag: '🇲🇪' },
  { code: 'MA', name: 'Morocco', ar: 'المغرب', dial: '+212', flag: '🇲🇦' },
  { code: 'MZ', name: 'Mozambique', ar: 'موزمبيق', dial: '+258', flag: '🇲🇿' },
  { code: 'MM', name: 'Myanmar', ar: 'ميانمار', dial: '+95', flag: '🇲🇲' },
  { code: 'NA', name: 'Namibia', ar: 'ناميبيا', dial: '+264', flag: '🇳🇦' },
  { code: 'NR', name: 'Nauru', ar: 'ناورو', dial: '+674', flag: '🇳🇷' },
  { code: 'NP', name: 'Nepal', ar: 'نيبال', dial: '+977', flag: '🇳🇵' },
  { code: 'NL', name: 'Netherlands', ar: 'هولندا', dial: '+31', flag: '🇳🇱' },
  { code: 'NZ', name: 'New Zealand', ar: 'نيوزيلندا', dial: '+64', flag: '🇳🇿' },
  { code: 'NI', name: 'Nicaragua', ar: 'نيكاراغوا', dial: '+505', flag: '🇳🇮' },
  { code: 'NE', name: 'Niger', ar: 'النيجر', dial: '+227', flag: '🇳🇪' },
  { code: 'NG', name: 'Nigeria', ar: 'نيجيريا', dial: '+234', flag: '🇳🇬' },
  { code: 'KP', name: 'North Korea', ar: 'كوريا الشمالية', dial: '+850', flag: '🇰🇵' },
  { code: 'MK', name: 'North Macedonia', ar: 'مقدونيا الشمالية', dial: '+389', flag: '🇲🇰' },
  { code: 'NO', name: 'Norway', ar: 'النرويج', dial: '+47', flag: '🇳🇴' },
  { code: 'OM', name: 'Oman', ar: 'عُمان', dial: '+968', flag: '🇴🇲' },
  { code: 'PK', name: 'Pakistan', ar: 'باكستان', dial: '+92', flag: '🇵🇰' },
  { code: 'PW', name: 'Palau', ar: 'بالاو', dial: '+680', flag: '🇵🇼' },
  { code: 'PS', name: 'Palestine', ar: 'فلسطين', dial: '+970', flag: '🇵🇸' },
  { code: 'PA', name: 'Panama', ar: 'بنما', dial: '+507', flag: '🇵🇦' },
  { code: 'PG', name: 'Papua New Guinea', ar: 'بابوا غينيا الجديدة', dial: '+675', flag: '🇵🇬' },
  { code: 'PY', name: 'Paraguay', ar: 'باراغواي', dial: '+595', flag: '🇵🇾' },
  { code: 'PE', name: 'Peru', ar: 'بيرو', dial: '+51', flag: '🇵🇪' },
  { code: 'PH', name: 'Philippines', ar: 'الفلبين', dial: '+63', flag: '🇵🇭' },
  { code: 'PL', name: 'Poland', ar: 'بولندا', dial: '+48', flag: '🇵🇱' },
  { code: 'PT', name: 'Portugal', ar: 'البرتغال', dial: '+351', flag: '🇵🇹' },
  { code: 'QA', name: 'Qatar', ar: 'قطر', dial: '+974', flag: '🇶🇦' },
  { code: 'RO', name: 'Romania', ar: 'رومانيا', dial: '+40', flag: '🇷🇴' },
  { code: 'RU', name: 'Russia', ar: 'روسيا', dial: '+7', flag: '🇷🇺' },
  { code: 'RW', name: 'Rwanda', ar: 'رواندا', dial: '+250', flag: '🇷🇼' },
  { code: 'KN', name: 'Saint Kitts and Nevis', ar: 'سانت كيتس ونيفيس', dial: '+1869', flag: '🇰🇳' },
  { code: 'LC', name: 'Saint Lucia', ar: 'سانت لوسيا', dial: '+1758', flag: '🇱🇨' },
  { code: 'VC', name: 'Saint Vincent', ar: 'سانت فنسنت والغرينادين', dial: '+1784', flag: '🇻🇨' },
  { code: 'WS', name: 'Samoa', ar: 'ساموا', dial: '+685', flag: '🇼🇸' },
  { code: 'SM', name: 'San Marino', ar: 'سان مارينو', dial: '+378', flag: '🇸🇲' },
  { code: 'ST', name: 'São Tomé and Príncipe', ar: 'ساو تومي وبرينسيب', dial: '+239', flag: '🇸🇹' },
  { code: 'SA', name: 'Saudi Arabia', ar: 'المملكة العربية السعودية', dial: '+966', flag: '🇸🇦' },
  { code: 'SN', name: 'Senegal', ar: 'السنغال', dial: '+221', flag: '🇸🇳' },
  { code: 'RS', name: 'Serbia', ar: 'صربيا', dial: '+381', flag: '🇷🇸' },
  { code: 'SC', name: 'Seychelles', ar: 'سيشل', dial: '+248', flag: '🇸🇨' },
  { code: 'SL', name: 'Sierra Leone', ar: 'سيراليون', dial: '+232', flag: '🇸🇱' },
  { code: 'SG', name: 'Singapore', ar: 'سنغافورة', dial: '+65', flag: '🇸🇬' },
  { code: 'SK', name: 'Slovakia', ar: 'سلوفاكيا', dial: '+421', flag: '🇸🇰' },
  { code: 'SI', name: 'Slovenia', ar: 'سلوفينيا', dial: '+386', flag: '🇸🇮' },
  { code: 'SB', name: 'Solomon Islands', ar: 'جزر سليمان', dial: '+677', flag: '🇸🇧' },
  { code: 'SO', name: 'Somalia', ar: 'الصومال', dial: '+252', flag: '🇸🇴' },
  { code: 'ZA', name: 'South Africa', ar: 'جنوب أفريقيا', dial: '+27', flag: '🇿🇦' },
  { code: 'KR', name: 'South Korea', ar: 'كوريا الجنوبية', dial: '+82', flag: '🇰🇷' },
  { code: 'SS', name: 'South Sudan', ar: 'جنوب السودان', dial: '+211', flag: '🇸🇸' },
  { code: 'ES', name: 'Spain', ar: 'إسبانيا', dial: '+34', flag: '🇪🇸' },
  { code: 'LK', name: 'Sri Lanka', ar: 'سريلانكا', dial: '+94', flag: '🇱🇰' },
  { code: 'SD', name: 'Sudan', ar: 'السودان', dial: '+249', flag: '🇸🇩' },
  { code: 'SR', name: 'Suriname', ar: 'سورينام', dial: '+597', flag: '🇸🇷' },
  { code: 'SE', name: 'Sweden', ar: 'السويد', dial: '+46', flag: '🇸🇪' },
  { code: 'CH', name: 'Switzerland', ar: 'سويسرا', dial: '+41', flag: '🇨🇭' },
  { code: 'SY', name: 'Syria', ar: 'سوريا', dial: '+963', flag: '🇸🇾' },
  { code: 'TW', name: 'Taiwan', ar: 'تايوان', dial: '+886', flag: '🇹🇼' },
  { code: 'TJ', name: 'Tajikistan', ar: 'طاجيكستان', dial: '+992', flag: '🇹🇯' },
  { code: 'TZ', name: 'Tanzania', ar: 'تنزانيا', dial: '+255', flag: '🇹🇿' },
  { code: 'TH', name: 'Thailand', ar: 'تايلاند', dial: '+66', flag: '🇹🇭' },
  { code: 'TL', name: 'Timor-Leste', ar: 'تيمور الشرقية', dial: '+670', flag: '🇹🇱' },
  { code: 'TG', name: 'Togo', ar: 'توغو', dial: '+228', flag: '🇹🇬' },
  { code: 'TO', name: 'Tonga', ar: 'تونغا', dial: '+676', flag: '🇹🇴' },
  { code: 'TT', name: 'Trinidad and Tobago', ar: 'ترينيداد وتوباغو', dial: '+1868', flag: '🇹🇹' },
  { code: 'TN', name: 'Tunisia', ar: 'تونس', dial: '+216', flag: '🇹🇳' },
  { code: 'TR', name: 'Turkey', ar: 'تركيا', dial: '+90', flag: '🇹🇷' },
  { code: 'TM', name: 'Turkmenistan', ar: 'تركمانستان', dial: '+993', flag: '🇹🇲' },
  { code: 'TV', name: 'Tuvalu', ar: 'توفالو', dial: '+688', flag: '🇹🇻' },
  { code: 'UG', name: 'Uganda', ar: 'أوغندا', dial: '+256', flag: '🇺🇬' },
  { code: 'UA', name: 'Ukraine', ar: 'أوكرانيا', dial: '+380', flag: '🇺🇦' },
  { code: 'AE', name: 'United Arab Emirates', ar: 'الإمارات العربية المتحدة', dial: '+971', flag: '🇦🇪' },
  { code: 'GB', name: 'United Kingdom', ar: 'المملكة المتحدة', dial: '+44', flag: '🇬🇧' },
  { code: 'US', name: 'United States', ar: 'الولايات المتحدة', dial: '+1', flag: '🇺🇸' },
  { code: 'UY', name: 'Uruguay', ar: 'الأوروغواي', dial: '+598', flag: '🇺🇾' },
  { code: 'UZ', name: 'Uzbekistan', ar: 'أوزبكستان', dial: '+998', flag: '🇺🇿' },
  { code: 'VU', name: 'Vanuatu', ar: 'فانواتو', dial: '+678', flag: '🇻🇺' },
  { code: 'VA', name: 'Vatican City', ar: 'الفاتيكان', dial: '+379', flag: '🇻🇦' },
  { code: 'VE', name: 'Venezuela', ar: 'فنزويلا', dial: '+58', flag: '🇻🇪' },
  { code: 'VN', name: 'Vietnam', ar: 'فيتنام', dial: '+84', flag: '🇻🇳' },
  { code: 'YE', name: 'Yemen', ar: 'اليمن', dial: '+967', flag: '🇾🇪' },
  { code: 'ZM', name: 'Zambia', ar: 'زامبيا', dial: '+260', flag: '🇿🇲' },
  { code: 'ZW', name: 'Zimbabwe', ar: 'زيمبابوي', dial: '+263', flag: '🇿🇼' },
];

export const COUNTRY_BY_CODE = Object.fromEntries(COUNTRIES.map(c => [c.code, c]));

/**
 * Search countries by English name, Arabic name, ISO code, or dial code.
 * Returns the full list when `query` is empty.
 */
export const searchCountries = (query) => {
  const q = (query || '').trim().toLowerCase();
  if (!q) return COUNTRIES;
  return COUNTRIES.filter(c =>
    c.name.toLowerCase().includes(q)
    || c.ar.includes(query.trim())
    || c.code.toLowerCase().includes(q)
    || c.dial.includes(q)
  );
};
